<template>
  <div class="ProductDetails" v-loading="loading">
    <!-- 产品中心详情 -->
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>产品中心</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span @click="goToHome" class="clickable">首页&nbsp;></span>
          <span @click="goToProductCenter" class="clickable">产品中心</span>
          <span v-if="$route.query.fromCategoryName">&nbsp;>&nbsp;{{ $route.query.fromCategoryName }}</span>
          <span>&nbsp;>&nbsp;产品详情</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="productDetailBox">
          <div class="contentBox_left">
            <div class="leftTop">
              <div class="leftTop_box">
                <div class="boxLeft">
                  <div class="boxLeft_xh">
                    <div class="boxLeft_img">
                      <img :src="itemImgSrc" alt="" />
                    </div>
                    <div class="boxLeft_bjt"></div>
                  </div>
                  <div class="xhText">
                    <img src="@/assets/img/spzx_xqy/cpzx_xh.png" alt="" />
                    <span>型号：{{ productItem.model }}</span>
                  </div>
                  <div class="boxLeft_xmtp">
                    <div class="cpzx_l" @click="moveBox_l">
                      <img src="@/assets/img/spzx_xqy/cpzx_z.png" alt="" />
                    </div>
                    <div class="productItemBox">
                      <div
                        class="item"
                        v-for="(item, index) in productItem.imgUrlList"
                        :key="index"
                        :style="{ transform: `translateX(${boxPosition}px)` }"
                        :class="[productItemIndex === index ? 'active' : '']"
                        @click="handleClickImg(item, index)"
                      >
                        <img :src="item" alt="" />
                      </div>
                    </div>
                    <div class="cpzx_r" @click="moveBox_r">
                      <img src="@/assets/img/spzx_xqy/cpzx_y.png" alt="" />
                    </div>
                  </div>
                </div>
                <div class="boxRight">
                  <div class="boxRight_title">
                    {{ productItem.productName }}
                  </div>
                  <div class="boxRight_content">
                    {{ productItem.brief }}
                  </div>
                  <ul class="boxRight_foot">
                    <li>
                      <img src="@/assets/img/spzx_xqy/cpxq_dh.png" alt="" />
                      <span>销售电话：{{ productItem.salesPhone }}</span>
                    </li>
                    <li>
                      <button @click="PopUp">留言</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="leftBottom">
              <ul class="leftBottom_top">
                <li class="titleChange">
                  产品介绍
                </li>
              </ul>
              <div class="leftBottom_foot">
                <!-- 产品介绍 -->
                <div v-html="productItem.productDescription"></div>
              </div>
            </div>
          </div>
          <div class="contentBox_right">
            <div class="tjcp">
              <div class="tjcpBox">
                <img src="@/assets/img/spzx_xqy/cpzx_tj.png" alt="" />
                <div>推荐产品</div>
              </div>
            </div>
            <div class="recommendItemBox">
              <!-- 可滚动的产品容器 -->
              <div class="scrollContainer"
                   :style="{ transform: `translateY(${recommendBoxPosition}px)` }">
                <div
                  class="item"
                  v-for="(item, index) in productArr"
                  :key="item.id"
                  @click="handleRecommend(item)"
                >
                  <img :src="item.imgUrlList[0]" alt="" />
                  <div>{{ item.productName }}</div>
                </div>
              </div>


              <!-- 推荐产品滚动指示器 - 替换原来的分页 -->
              <div class="scrollIndicatorBottom" v-show="shouldShowScrollArrows()">
                <div class="indicatorContent">
                  <div class="arrowButtons">
                    <img
                      src="@/assets/img/spzx_xqy/cpzx_z.png"
                      alt="上一页"
                      @click="recommendMove_l"
                      :class="{ disabled: !getScrollPageInfo().canScrollUp }"
                      title="上一页"
                    />
                    <img
                      src="@/assets/img/spzx_xqy/cpzx_y.png"
                      alt="下一页"
                      @click="recommendMove_r"
                      :class="{ disabled: !getScrollPageInfo().canScrollDown }"
                      title="下一页"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加留言 -->
    <m-dialog
      title="请输入留言内容"
      :visble.sync="addBialogVisible"
      width="600px"
      append-to-body
      destroy-on-close
    >
      <el-form
        :rules="addRules"
        :model="addFrom"
        ref="addFrom"
        status-icon
        label-position="top"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addFrom.name" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="department">
          <el-input
            v-model="addFrom.department"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <el-form-item label="职务" prop="title">
          <el-input v-model="addFrom.title" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="addFrom.phone" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="留言内容" prop="comment">
          <el-input
            type="textarea"
            v-model="addFrom.comment"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <div class="dialog-footer">
          <el-button @click="addBialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmitForm('addFrom')"
            >确 定</el-button
          >
        </div>
      </el-form>
    </m-dialog>
  </div>
</template>

<script>
import Product from "@/api/product.js";
import MessageCenter from "@/api/messageCenter.js";
export default {
  name: "ProductDetails",
  data() {
    return {
      productTitleArr: ["产品介绍", "产品详情"],
      productTitleIndex: 0,
      yctpArr: [
        {
          id: "001",
          url: require("@/assets/img/spzx_xqy/cpzx_tu12.png"),
          text: "移动式病虫疫情测报站"
        },
        {
          id: "002",
          url: require("@/assets/img/spzx_xqy/cpzx_tu13.png"),
          text: "物联网高空虫情测报系统"
        },
        {
          id: "003",
          url: require("@/assets/img/spzx_xqy/cpzx_tu14.png"),
          text: "鼠害监测预警系统"
        },
        {
          id: "004",
          url: require("@/assets/img/spzx_xqy/cpzx_tu12.png"),
          text: "鼠害监测预警系统"
        },
        {
          id: "005",
          url: require("@/assets/img/spzx_xqy/cpzx_tu13.png"),
          text: "鼠害监测预警系统"
        }
      ],
      // 产品数据
      // productArr: [
      //   {
      //     id: "01",
      //     url: require("@/assets/img/spzx_xqy/tu11.png")
      //   },

      //   {
      //     id: "02",
      //     url: require("@/assets/img/spzx_xqy/cpzx_tu14.png")
      //   },
      //   {
      //     id: "03",
      //     url: require("@/assets/img/spzx_xqy/tu11.png")
      //   },
      //   {
      //     id: "04",
      //     url: require("@/assets/img/spzx_xqy/tu11.png")
      //   },
      //   {
      //     id: "05",
      //     url: require("@/assets/img/spzx_xqy/tu11.png")
      //   },
      //   {
      //     id: "06",
      //     url: require("@/assets/img/spzx_xqy/tu11.png")
      //   }
      // ],
      // 左侧盒子移动距离
      boxPosition: 0,
      productItemIndex: 0,
      itemImgSrc: require("@/assets/img/spzx_xqy/tu11.png"),
      recommendBoxPosition: 0,
      productItem: {},
      productArr: [],
      addBialogVisible: false,
      addFrom: {
        id: "", // 主键 ID，UUID 格式
        name: "", // 姓名
        department: "", // 所属部门
        title: "", // 职务头衔
        phone: "", // 联系电话
        comment: "", // 留言内容
        checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
        delStatus: 0, // 逻辑删除：0-未删除，1-已删除
        handleComment: "" //处理内容
      },
      addRules: {
        name: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        department: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的11位手机号" }
        ],
        comment: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ]
      },
      recommendPage: 1,
      recommendPageSize: 20, // 增加每页数量，减少分页
      recommendTotal: 0,
      loading: false
    };
  },
  methods: {
    // 返回首页
    goToHome() {
      this.$LocalCache.setCath("navigationBarIndex", 0);
      this.$router.push({ name: 'Home' });
    },
    // 返回产品中心
    goToProductCenter() {
      this.$LocalCache.setCath("navigationBarIndex", 1);

      // 获取来源分类信息
      const { fromCategoryId, fromCategoryName } = this.$route.query;

      if (fromCategoryId && fromCategoryName) {
        // 如果有来源分类信息，返回到对应分类
        this.$router.push({
          name: 'ProductCenter',
          query: {
            categoryId: fromCategoryId,
            categoryName: fromCategoryName
          }
        });
      } else {
        // 如果没有来源分类信息，返回到全部产品
        this.$router.push({ name: 'ProductCenter' });
      }
    },
    handleProductTitle(index) {
      this.productTitleIndex = index;
    },
    //左侧盒子左箭头点击事件
    moveBox_l() {
      this.boxPosition = this.boxPosition + -76;
      if (this.boxPosition === -76 * this.productItem.imgUrlList.length) {
        this.boxPosition = 0;
      }
    },
    //左侧盒子右箭头点击事件
    moveBox_r() {
      if (this.boxPosition === 0) {
        this.boxPosition = 0;
      } else {
        this.boxPosition = this.boxPosition + 76;
      }
    },
    //左侧盒子图片点击事件
    handleClickImg(item, index) {
      this.productItemIndex = index;
      this.itemImgSrc = item;
    },
    // 右侧盒子左箭头点击事件 (向上滚动，显示前面的产品)
    recommendMove_l() {
      // 检查是否可以向上滚动
      if (this.recommendBoxPosition >= 0) {
        return; // 已经在顶部，不能再向上滚动
      }

      // 计算可见区域能显示的item数量 (容器高度 / 单个item高度)
      const containerHeight = 420; // 实际可用高度 (500 - 80底部空间)
      const itemHeight = 194; // 单个item高度 (186 + 8间距)
      const scrollStep = itemHeight; // 每次滚动一个item的距离

      // 向上滚动 (减少负值，回到顶部)
      this.recommendBoxPosition = Math.min(0, this.recommendBoxPosition + scrollStep);
    },
    // 右侧盒子右箭头点击事件 (向下滚动，显示后面的产品)
    recommendMove_r() {
      // 计算可见区域能显示的item数量
      const containerHeight = 420; // 实际可用高度
      const itemHeight = 194; // 单个item高度
      const scrollStep = itemHeight; // 每次滚动一个item的距离
      const visibleCount = Math.floor(containerHeight / itemHeight); // 可见item数量
      const maxItems = this.productArr.length;

      // 计算最大可滚动距离 (总item数 - 可见item数) * item高度
      const maxScrollDistance = Math.max(0, (maxItems - visibleCount) * itemHeight);

      // 检查是否可以向下滚动
      if (Math.abs(this.recommendBoxPosition) >= maxScrollDistance) {
        return; // 已经在底部，不能再向下滚动
      }

      // 向下滚动 (增加负值，向下移动)
      this.recommendBoxPosition = Math.max(-maxScrollDistance, this.recommendBoxPosition - scrollStep);
    },
    //获取产品列表
    async getProductList() {
      const params = {
        // startStatus: 1,
        productName: "",
        productTypeId: "", //产品分类id
        page: this.recommendPage,
        pageSize: this.recommendPageSize,
        startTime: "",
        endTime: ""
      };
      const { code, msg, data, total } = await Product.queryList(params);
      if (code === 200) {
        // 过滤启用状态的推荐产品，并处理每个产品的图片URL
        this.productArr = (data || []).filter(product => product.betterStatus === 1).map(product => {
          if (product.imageUrl) {
            try {
              // imageUrl是JSON字符串数组，需要解析
              const imageUrlArray = JSON.parse(product.imageUrl);
              if (Array.isArray(imageUrlArray)) {
                product.imgUrlList = imageUrlArray;
              } else {
                product.imgUrlList = [product.imageUrl];
              }
            } catch (parseError) {
              console.warn('解析推荐产品图片URL失败:', parseError);
              product.imgUrlList = [product.imageUrl];
            }
          } else {
            product.imgUrlList = [];
          }
          return product;
        });

        this.recommendTotal = total;
        // 重置滚动位置当数据更新时
        this.recommendBoxPosition = 0;
      } else {
        this.$message.error(msg);
      }
    },
    //推荐产品点击事件
    handleRecommend(item) {
      // 获取当前的分类信息
      const { fromCategoryId, fromCategoryName } = this.$route.query;

      if (item && item.id) {
        // 更新路由，保持分类信息
        this.$router.push({
          name: "ProductDetails",
          query: {
            projectId: item.id.toString(), // 传递产品ID
            // 保持原有的分类信息
            fromCategoryId: fromCategoryId,
            fromCategoryName: fromCategoryName
          }
        });

        // 推荐产品切换后自动滚动到主要内容区域
        this.$nextTick(() => {
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            // 计算面包屑导航的高度，确保面包屑显示在视口中
            const breadcrumb = document.querySelector('.breadcrumb');
            const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
            const bannerHeight = 274; // banner的固定高度

            // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
            window.scrollTo({
              top: bannerHeight + breadcrumbHeight - 10,
              behavior: 'smooth'
            });
          }
        });
      } else {
        this.$message.error('产品数据异常，无法查看详情');
      }
    },
    //留言弹窗
    PopUp() {
      this.addBialogVisible = true;
    },
    //留言提交
    addSubmitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            name: this.addFrom.name, // 姓名
            department: this.addFrom.department, // 所属部门
            title: this.addFrom.title, // 职务/头衔
            phone: this.addFrom.phone, // 联系电话
            comment: this.addFrom.comment, // 留言内容
            checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
            delStatus: 0 // 逻辑删除：0-未删除，1-已删除
          };
          const { code, msg, data } = await MessageCenter.addOrUpDateList(
            params
          );
          if (code === 200) {
            this.$message({
              message: msg,
              type: "success"
            });
            this.addFrom = {
              id: "", // 主键 ID，UUID 格式
              name: "", // 姓名
              department: "", // 所属部门
              title: "", // 职务头衔
              phone: "", // 联系电话
              comment: "", // 留言内容
              checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
              delStatus: 0, // 逻辑删除：0-未删除，1-已删除
              handleComment: "" //处理内容
            };
            this.addBialogVisible = false;
          } else {
            this.$message.error(msg);
          }
        } else {
          return false;
        }
      });
    },
    // 初始化图片显示，确保主图与缩略图同步
    initializeProductImages() {
      // 重置图片相关状态
      this.productItemIndex = 0;
      this.boxPosition = 0;

      // 检查产品数据和图片列表是否存在
      if (this.productItem &&
          this.productItem.imgUrlList &&
          Array.isArray(this.productItem.imgUrlList) &&
          this.productItem.imgUrlList.length > 0) {
        // 如果产品有图片列表，设置第一张图片为主图
        this.itemImgSrc = this.productItem.imgUrlList[0];
      } else {
        // 如果没有图片，使用默认图片
        this.itemImgSrc = require("@/assets/img/spzx_xqy/tu11.png");
      }
    },
    // 推荐产品分页改变 (现在主要用于数据获取，不是真正的分页)
    handleRecommendPageChange(page) {
      this.recommendPage = page;
      this.recommendBoxPosition = 0; // 重置滚动位置
      this.getProductList();
    },
    // 获取产品详情
    async getProductDetail(projectId) {
      this.loading = true;
      try {
        const { code, msg, data } = await Product.getDetail({ projectId });
        if (code === 200) {
          this.productItem = data;

          // 处理图片URL数据
          if (data.imageUrl) {
            try {
              // imageUrl是JSON字符串数组，需要解析
              const imageUrlArray = JSON.parse(data.imageUrl);
              if (Array.isArray(imageUrlArray)) {
                // 将解析后的图片数组赋值给imgUrlList
                this.productItem.imgUrlList = imageUrlArray;
              } else {
                // 如果不是数组，则作为单个图片处理
                this.productItem.imgUrlList = [data.imageUrl];
              }
            } catch (parseError) {
              console.warn('解析图片URL失败:', parseError);
              // 如果解析失败，尝试直接使用imageUrl
              this.productItem.imgUrlList = [data.imageUrl];
            }
          } else {
            // 如果没有imageUrl，使用空数组
            this.productItem.imgUrlList = [];
          }

          this.initializeProductImages();
        } else {
          this.$message.error(msg || '获取产品详情失败');
        }
      } catch (error) {
        console.error('获取产品详情失败:', error);
        this.$message.error('获取产品详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 检查是否需要显示滚动箭头
    shouldShowScrollArrows() {
      const containerHeight = 420;
      const itemHeight = 194;
      const visibleCount = Math.floor(containerHeight / itemHeight);
      return this.productArr.length > visibleCount;
    },
    // 获取当前滚动信息
    getScrollInfo() {
      const containerHeight = 420;
      const itemHeight = 194;
      const visibleCount = Math.floor(containerHeight / itemHeight);
      const maxItems = this.productArr.length;
      const currentIndex = Math.abs(Math.round(this.recommendBoxPosition / itemHeight));
      const maxIndex = Math.max(0, maxItems - visibleCount);

      return {
        currentIndex,
        maxIndex,
        canScrollUp: this.recommendBoxPosition < 0,
        canScrollDown: currentIndex < maxIndex,
        visibleCount,
        totalCount: maxItems
      };
    },
    // 获取滚动页面信息
    getScrollPageInfo() {
      const scrollInfo = this.getScrollInfo();
      const currentPage = Math.floor(scrollInfo.currentIndex / scrollInfo.visibleCount) + 1;
      const totalPages = Math.ceil(scrollInfo.totalCount / scrollInfo.visibleCount);

      return {
        currentPage,
        totalPages,
        canScrollUp: scrollInfo.canScrollUp,
        canScrollDown: scrollInfo.canScrollDown
      };
    }
  },
  watch: {
    // 监听路由参数变化
    '$route'(to, from) {
      if (to.query.projectId !== from.query.projectId) {
        // 当产品ID变化时，重新获取产品详情
        this.getProductDetail(to.query.projectId);

        // 路由变化时自动滚动到主要内容区域
        this.$nextTick(() => {
          const mainContent = document.getElementById('main-content');
          if (mainContent) {
            // 计算面包屑导航的高度，确保面包屑显示在视口中
            const breadcrumb = document.querySelector('.breadcrumb');
            const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
            const bannerHeight = 274; // banner的固定高度

            // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
            window.scrollTo({
              top: bannerHeight + breadcrumbHeight - 10,
              behavior: 'smooth'
            });
          }
        });
      }
    }
  },
  mounted() {
    // 获取产品详情
    const projectId = this.$route.query.projectId;
    if (projectId) {
      this.getProductDetail(projectId);
    } else {
      this.$message.error('缺少产品ID参数');
      // 返回产品中心
      this.goToProductCenter();
    }

    // 获取推荐产品列表
    this.getProductList();

    // 页面加载后自动滚动到核心内容区域
    this.$nextTick(() => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        // 计算面包屑导航的高度，确保面包屑显示在视口中
        const breadcrumb = document.querySelector('.breadcrumb');
        const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
        const bannerHeight = 274; // banner的固定高度

        // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
        window.scrollTo({
          top: bannerHeight + breadcrumbHeight - 10,
          behavior: 'smooth'
        });
      }
    });
  }
};
</script>

<style scoped lang="scss">
.ProductDetails {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }

        &:nth-child(3) {
          color: #2b8737;
        }

        &:nth-child(4) {
          color: #2b8737;
        }

        &.clickable {
          cursor: pointer;

          &:hover {
            opacity: 0.7;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 24px 0 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      .productDetailBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .contentBox_left {
          width: 924px;
          .leftTop {
            width: 100%;
            background-color: #fff;
            padding: 28px;
            margin-bottom: 24px;
            .leftTop_box {
              width: 100%;
              display: flex;
              justify-content: space-between;
              .boxLeft {
                width: 352px;
                position: relative;
                .boxLeft_xh {
                  width: 352px;
                  height: 352px;

                  .boxLeft_img {
                    width: 100%;
                    height: 282px;
                    display: flex;
                    justify-content: center;
                    img {
                      width: 100%;
                      height: 282px;
                    }
                  }
                  .boxLeft_bjt {
                    width: 352px;
                    height: 456px;
                    background: url("../../assets/img/spzx_xqy/cpzx_tbg.png")
                      no-repeat;
                    background-size: 100% 352px;
                    position: absolute;
                    top: 0;
                    left: 0;
                  }
                }
                .xhText {
                  width: 100%;
                  height: 50px;
                  position: absolute;
                  bottom: 82px;
                  left: 0;
                  display: flex;
                  align-items: center;
                  padding-left: 20px;
                  img {
                    width: 24px;
                    height: 24px;
                  }
                  span {
                    padding-left: 10px;
                    color: #fff;
                  }
                }
                .boxLeft_xmtp {
                  width: 100%;
                  height: 62px;
                  margin-top: 20px;
                  display: flex;
                  padding: 0 6px;
                  .cpzx_l,
                  .cpzx_r {
                    width: 14px;
                    height: 62px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    img {
                      width: 14px;
                      height: 24px;
                    }
                  }
                  .cpzx_l {
                    cursor: pointer;
                    opacity: 0.7;
                  }
                  .cpzx_r {
                    cursor: pointer;
                    opacity: 0.7 !important;
                  }

                  .productItemBox {
                    width: 310px;
                    height: 62px;
                    display: flex;
                    margin: 0 6px;
                    padding: 0 4px;
                    overflow: hidden;
                    .item {
                      width: 70px;
                      min-width: 70px;
                      max-width: 70px;
                      min-height: 62px;
                      height: 62px;
                      position: relative;
                      border: 1px solid #e7e7e7;
                      margin-left: 5px;
                      transition: all 0.5s;
                      &:hover {
                        cursor: pointer;
                        opacity: 0.7;
                      }
                      img {
                        height: 60px;
                        object-fit: contain;
                      }
                      &:nth-child(1) {
                        margin-left: 0px !important;
                      }
                    }
                    .active {
                      border: 1px solid #19b45f !important;
                    }
                  }
                }
              }
              .boxRight {
                width: 488px;
                .boxRight_title {
                  width: 100%;
                  height: 48px;
                  line-height: 48px;
                  font-size: 20px;
                  font-weight: 700;
                  text-align: center;
                  border-bottom: 1px solid #e4e4e4;
                }
                .boxRight_content {
                  width: 100%;
                  padding: 20px 0;
                  font-size: 14px;
                  line-height: 18px;
                  max-height: 152px;
                  overflow: auto;
                  border-bottom: 1px solid #e4e4e4;
                }
                .boxRight_foot {
                  width: 100%;
                  margin-top: 16px;
                  margin-left: 10px;
                  position: relative;
                  li {
                    &:nth-child(1) {
                      width: 100%;
                      height: 22px;
                      img {
                        width: 23px;
                        height: 22px;
                      }
                      span {
                        display: block;
                        width: 310px;
                        height: 22px;
                        font-size: 18px;
                        font-weight: 700;
                        position: absolute;
                        top: 2px;
                        left: 30px;
                      }
                    }
                    &:nth-child(2) {
                      width: 100%;
                      height: 46px;
                      margin-top: 18px;
                      button {
                        width: 180px;
                        height: 46px;
                        background-color: #1c7e28;
                        color: #fff;
                        line-height: 46px;
                        text-align: center;
                        border-color: transparent;
                        &:hover {
                          cursor: pointer;
                          opacity: 0.7;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .leftBottom {
            width: 100%;
            background-color: #fff;
            .leftBottom_top {
              width: 100%;
              height: 40px;
              display: flex;
              border-top: 1px solid #eeeeee;
              border-bottom: 1px solid #eeeeee;
              background-color: #f7f7f7;
              li {
                width: 100px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                position: relative;
                color: #646464;
                &:hover {
                  cursor: pointer;
                  opacity: 0.7;
                }
              }
              .titleChange {
                background-color: #fff;
                color: #19b45f;
                &:after {
                  content: "";
                  width: 100%;
                  height: 6px;
                  background-color: #1d7e28;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
            }
            .leftBottom_foot {
              width: 100%;
              padding: 22px 12px;
              min-height: 400px;
              div {
                font-size: 14px;
                line-height: 24px;
              }
            }
          }
        }
        .contentBox_right {
          width: 260px;
          background-color: #fff;
          border: 1px solid #1d7e28;
          align-self: flex-start;
          .tjcp {
            width: 100%;
            height: 62px;
            background-color: #1c7e28;
            display: flex;
            justify-content: center;
            align-items: center;
            .tjcpBox {
              width: 118px;
              height: 28px;
              display: flex;
              img {
                width: 24px;
                height: 23px;
              }
              div {
                height: 28px;
                color: #fff;
                font-size: 20px;
                margin-left: 8px;
                margin-top: 2px;
              }
            }
          }
          .recommendItemBox {
            width: 100%;
            margin-top: 22px;
            position: relative;
            height: 500px; // 固定容器高度
            overflow: hidden; // 隐藏溢出内容

            .scrollContainer {
              width: 100%;
              height: auto; // 允许内容高度超出，但通过父容器overflow控制
              overflow: visible;
              position: relative;
              transition: transform 0.3s ease; // 添加平滑滚动动画
              padding-bottom: 60px; // 为底部控件留出空间，减少一些空间
            }

            .item {
              width: 100%;
              min-width: 100%;
              min-height: 186px;
              height: 186px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-top: 8px; // 减少间距
              transition: all 0.3s ease; // 优化动画效果
              &:hover {
                cursor: pointer;
                opacity: 0.8;
                transform: scale(1.02); // 添加悬停缩放效果
              }
              &:first-child {
                margin-top: 0; // 第一个item不需要顶部间距
              }
              img {
                width: 84px;
                height: 120px;
                object-fit: contain; // 保持图片比例
              }
              div {
                height: 18px;
                font-size: 14px; // 略微减小字体
                margin-top: 16px; // 减少间距
                text-align: center;
                padding: 0 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                box-sizing: border-box;
              }
            }

            .scrollIndicatorBottom {
              width: 100%;
              height: 50px; // 增加高度让布局更舒适
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 0;
              left: 0;
              background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); // 渐变背景
              border-top: 2px solid #e9ecef; // 更明显的分隔线
              box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08); // 向上的阴影

              .indicatorContent {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                max-width: 120px; // 调整宽度以适应只有箭头的布局
                padding: 8px 16px;
                background-color: rgba(255, 255, 255, 0.9);
                border-radius: 20px; // 圆角胶囊形状
                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
                border: 1px solid #e9ecef;

                .arrowButtons {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 20px; // 增加按钮间距让布局更均匀
                  width: 100%;

                  img {
                    width: 20px;
                    height: 20px;
                    padding: 6px;
                    background-color: #ffffff;
                    border-radius: 50%; // 圆形按钮
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); // 更平滑的动画
                    cursor: pointer;
                    box-shadow: 0 2px 6px rgba(28, 126, 40, 0.2);

                    &:hover {
                      background-color: #1c7e28;
                      transform: scale(1.1) translateY(-2px);
                      box-shadow: 0 4px 12px rgba(28, 126, 40, 0.3);
                      filter: brightness(1.1);
                    }

                    &:active {
                      transform: scale(0.95) translateY(0);
                      box-shadow: 0 2px 6px rgba(28, 126, 40, 0.2);
                    }

                    &.disabled {
                      background-color: #f8f9fa;
                      border-color: #dee2e6;
                      opacity: 0.4;
                      cursor: not-allowed;
                      box-shadow: none;

                      &:hover {
                        background-color: #f8f9fa;
                        transform: none;
                        box-shadow: none;
                        filter: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
/* 分页组件全局样式 */
.ProductDetails .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}

.ProductDetails .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}

.ProductDetails .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}

.ProductDetails .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/productDetails/ProductDetails.vue